import { NavigationEvent, NavigationEventBuilder } from '@spartacus/storefront'
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { ActivatedRouterStateSnapshot, createFrom } from '@spartacus/core'
import { ofType } from '@ngrx/effects'
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store'

@Injectable({
  providedIn: 'root',
})
export class MbNavigationEventBuilder extends NavigationEventBuilder {

  previousState: ActivatedRouterStateSnapshot | undefined

  protected buildNavigationEvent () {
    return this.getMbNavigatedEvent().pipe(
      map(state => {
        const navigationEvent = createFrom(NavigationEvent, {
          context: state.context,
          semanticRoute: state.semanticRoute,
          url: state.url,
          params: state.params,
          previousUrl: this.previousState?.url
        })
        this.previousState = state
        return navigationEvent
      })
    )
  }

  private getMbNavigatedEvent () {
    return this.actions.pipe(
      ofType<RouterNavigatedAction<ActivatedRouterStateSnapshot>>(ROUTER_NAVIGATED),
      map(event => event.payload.routerState)
    )
  }
}
